import { fetchAppSetting, upsertAppSetting } from "./db";

export const TEAM_PERMS_KEY = "team_permissions_v2";

// All toggleable client profile tabs in the practice portal
export const CLIENT_TABS = [
  { id: "Dashboard",       label: "Dashboard" },
  { id: "Overview",        label: "Overview" },
  { id: "Communications",  label: "Communications" },
  { id: "Tasks",           label: "Tasks" },
  { id: "Deadlines",       label: "Deadlines" },
  { id: "Planner",         label: "Planner" },
  { id: "Documents",       label: "Documents" },
  { id: "PI Score",        label: "PI Score" },
  { id: "Acceptance",      label: "Acceptance" },
  { id: "Portal",          label: "Portal" },
  { id: "Accounting",      label: "Accounting" },
  { id: "Payroll",         label: "Payroll" },
  { id: "Sales Orders",    label: "Sales Orders" },
  { id: "Purchasing",      label: "Purchasing" },
  { id: "Back Office",     label: "Back Office" },
  { id: "Tax & Compliance",label: "Tax & Compliance" },
  { id: "Xero",            label: "Xero" },
  { id: "Personal Space",  label: "Personal Space" },
  { id: "Time",            label: "Time" },
  { id: "Video Call",      label: "Video Call" },
];

// Shape:
// {
//   members: [
//     {
//       authUserId: "uuid",
//       email: "jane@example.com",
//       name: "Jane",
//       clientIds: [1, 5, 12],          // which clients they can see
//       tabs: { "1": { Dashboard: true, Overview: true, Tasks: false, ... },
//               "5": { ... } }
//     }
//   ]
// }

export async function loadTeamPermissions() {
  try {
    const raw = await fetchAppSetting(TEAM_PERMS_KEY);
    if (!raw) return { members: [] };
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    return parsed && parsed.members ? parsed : { members: [] };
  } catch {
    return { members: [] };
  }
}

export async function saveTeamPermissions(data) {
  await upsertAppSetting(TEAM_PERMS_KEY, data);
}

export function getMemberByEmail(permData, email) {
  if (!email || !permData?.members) return null;
  return permData.members.find(m => m.email?.toLowerCase() === email.toLowerCase()) || null;
}

export function defaultTabsForClient(clientId) {
  const tabs = {};
  CLIENT_TABS.forEach(t => { tabs[t.id] = true; });
  return tabs;
}

export function canAccessTab(member, clientId, tabId) {
  if (!member) return true; // owner sees everything
  const cid = String(clientId);
  if (!member.clientIds?.includes(Number(clientId)) && !member.clientIds?.includes(cid)) return false;
  const tabPerms = member.tabs?.[cid];
  if (!tabPerms) return true; // if no tab perms set, allow all (safer default)
  return tabPerms[tabId] !== false;
}
